import { msg } from '@lingui/core/macro';

export const CLOSE_TEXT = msg`Close`;
export const DELETE_REPLY_TEXT = msg`Delete reply`;
export const SUBMIT_REPLY_TEXT = msg`Submit reply`;
export const SKIP_TEXT = msg`Skip`;
export const OK_TEXT = msg`OK`;
